/* Precision Colors product page. Added 2026-10-07. Not a Hyper file.
   Keeps three things in step with the size picked in the main product form:
   1. the color dots link to the same size of the other colors
   2. the "Add more colors" tiles add that size (and can be switched there too)
   3. the Add to Cart button says which size and price it adds
   Also adds "Read more" to a long description on phones. */
(function () {
  if (window.__pcProductInit) return;
  window.__pcProductInit = true;

  var keyOf = function (s) { return String(s || '').toLowerCase().replace(/\s+/g, ''); };

  function main() { return document.querySelector('product-info.section-main-product, .section-main-product'); }

  function currentSize() {
    var m = main();
    if (!m) return null;
    var input = m.querySelector('variant-selects input[type=radio][data-option-name="Size"]:checked');
    if (!input) return null;
    var label = m.querySelector('label[for="' + input.id + '"]');
    var amount = label ? label.querySelector('.pc-size__amount') : null;
    var name = label ? label.querySelector('.pc-size__label') : null;
    return {
      key: keyOf(input.value),
      label: name ? name.textContent.trim() : input.value,
      price: amount ? amount.textContent.trim() : ''
    };
  }

  function updateDots(key) {
    document.querySelectorAll('[data-pc-colors] a[data-variants]').forEach(function (a) {
      var id = null;
      a.dataset.variants.split(',').forEach(function (pair) {
        var p = pair.split(':');
        if (p[0] === key) id = p[1];
      });
      a.href = id ? a.dataset.url + '?variant=' + id : a.dataset.url;
    });
  }

  function setMoreSize(section, key) {
    section.dataset.current = key;
    section.querySelectorAll('.pc-more__chip').forEach(function (c) {
      var on = c.dataset.size === key;
      c.classList.toggle('is-on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    section.querySelectorAll('.pc-more__tile').forEach(function (tile) {
      var data = tile.querySelector('script[data-variants]');
      if (!data) return;
      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }
      var v = variants[key];
      var input = tile.querySelector('input[name="id"]');
      var btn = tile.querySelector('.pc-more__add');
      var text = tile.querySelector('[data-add-label]');
      var price = tile.querySelector('[data-price]');
      if (!input || !btn || !text) return;
      if (!v) {
        btn.disabled = true; input.disabled = true;
        text.textContent = 'Not in this size';
        return;
      }
      input.value = v.id;
      if (price) price.textContent = v.price;
      input.disabled = !v.available;
      btn.disabled = !v.available;
      text.textContent = v.available ? 'Add ' + v.label : 'Out of stock';
    });
  }

  var baseLabel = null;
  var writing = false;
  function updateButton(size) {
    var m = main();
    if (!m || !size || !size.price) return;
    var btn = m.querySelector('.product-form__submit');
    var text = btn ? btn.querySelector('.btn__text') : null;
    if (!text) return;
    var strings = (window.FoxTheme && window.FoxTheme.variantStrings) || {};
    if (baseLabel === null) baseLabel = (strings.addToCart || text.textContent || 'Add to cart').trim();
    var now = text.textContent.trim();
    // Only decorate the plain "Add to cart" state. Sold out, unavailable and so on stay as Hyper wrote them.
    if (btn.disabled || (now !== baseLabel && now.indexOf(baseLabel + ',') !== 0)) return;
    var want = baseLabel + ', ' + size.label + ' for ' + size.price;
    if (now === want) return;
    writing = true;
    text.textContent = want;
    writing = false;
  }

  function sync() {
    var size = currentSize();
    if (!size) return;
    updateDots(size.key);
    document.querySelectorAll('[data-pc-more]').forEach(function (s) { setMoreSize(s, size.key); });
    updateButton(size);
  }

  function init() {
    var m = main();
    if (!m) return;

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('variant-selects input[type=radio]')) {
        // Hyper may re-render the form after a change, so run now and again once it settles.
        sync(); setTimeout(sync, 60); setTimeout(sync, 600);
      }
    });

    document.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('.pc-more__chip') : null;
      if (!chip) return;
      var section = chip.closest('[data-pc-more]');
      if (section) setMoreSize(section, chip.dataset.size);
    });

    // Hyper rewrites the button text when the variant changes; put the size and price back after it does.
    var btnText = m.querySelector('.product-form__submit .btn__text');
    if (btnText && window.MutationObserver) {
      new MutationObserver(function () {
        if (writing) return;
        var size = currentSize();
        if (size) updateButton(size);
      }).observe(btnText, { childList: true, characterData: true, subtree: true });
    }

    sync();
  }

  // Phones: a long description shows its first lines and a "Read more" button (styles in pc-product.css).
  function readMore() {
    var box = document.querySelector('.section-main-product .product__block--collapsible_tab .accordion-details__content');
    if (!box || box.dataset.pcReadmore || box.textContent.trim().length < 420) return;
    box.dataset.pcReadmore = '1';
    box.classList.add('pc-readmore');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pc-readmore-btn';
    btn.textContent = 'Read more';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-open');
      btn.textContent = open ? 'Show less' : 'Read more';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    box.parentNode.insertBefore(btn, box.nextSibling);
  }

  function start() {
    try { readMore(); } catch (e) {}
    init();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
